import React, { useState } from "react";
import { Box, Button, Container, TextField, Typography } from '@mui/material';
import { useLoginMobile, useSendLoginCode } from "../../hooks/useLogin";
import { useAuth } from "../../context/AuthContext";
import { Formik, Form } from "formik";
import CustomButton from "components/buttons/CustomButton/CustomButton";
import CustomText from "components/common/CustomText/CustomText";
import { colors } from "styles/colors";

export default function LoginScreen() {
  const { login } = useAuth();
  const [error, setError] = useState<string>('');
  const [showCode, setShowCode] = useState<boolean>(false);

  const { mutate: sendLoginCode, isLoading } = useSendLoginCode(
    async (data: any) => {
      setShowCode(true);
    },
    (error: any) => {
      console.log('error send code', error);
      setError(error?.message);
    }
  );

  const { mutate: loginMobile } = useLoginMobile(
    async (data: any) => {
      await login(data);
      console.log('data', data);
    },
    (error: any) => {
      console.log('error login', error);
      setError(error?.message);
    }
  );

  const handleSubmit = async (values: any) => {
    setError('');
    if (values.code) {
      loginMobile({ phoneCode: values.phoneCode, number: values.number, code: values.code });
    } else {
      sendLoginCode({ phoneCode: values.phoneCode, number: values.number });
    }
  }

  return (
    <Container sx={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      <Box sx={{
        width: 500,
      }}>
        <Formik
          initialValues={{ phoneCode: "970", number: "", code: "", }}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          {({ handleChange, values }) => (
            <Form>
              <Box display="grid" gap={2}>
                <TextField
                  label="Phone code"
                  value={values.phoneCode}
                  name="phoneCode"
                  onChange={handleChange}
                  fullWidth
                />

                <TextField
                  label="Phone number"
                  value={values.number}
                  name="number"
                  onChange={handleChange}
                  fullWidth
                />

                {showCode && <TextField
                  label="Verification code"
                  value={values.code}
                  name="code"
                  onChange={handleChange}
                  fullWidth
                />}
              </Box>

              <Box sx={{ marginTop: 2 }}>
                {error && (<CustomText text={error} color={colors.error} />)}
              </Box>

              <Box mt={3}>
                <CustomButton
                  text="Submit"
                  color="primary"
                  type="submit"
                  fullWidth
                  loading={isLoading}
                />
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Container>
  );
}

const styles = {
  container: {
    backgroundColor: 'red',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100vw',
    height: '100vh',
    margin: 0,
    padding: 0,
  }
};
